import { withProps } from 'recompose';
import { noop } from 'lodash';

export default withProps(({ input: { value, onBlur = noop } }) => ({
  // look for issue https://github.com/JedWatson/react-select/issues/805#issuecomment-250530638 @sinslav @lukavyi
  onBlur: () => {
    onBlur(value);
  },
}));
